import { render } from "./WorkoutManager.vue?vue&type=template&id=594d9f78&scoped=true&ts=true"
import script from "./WorkoutManager.vue?vue&type=script&lang=ts"
export * from "./WorkoutManager.vue?vue&type=script&lang=ts"

import "./WorkoutManager.vue?vue&type=style&index=0&id=594d9f78&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594d9f78"]])

export default __exports__